import { useEffect } from 'react';

interface SEOJsonLdProps {
  data: Record<string, unknown>;
  id: string;
}

export default function SEOJsonLd({ data, id }: SEOJsonLdProps) {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [id, JSON.stringify(data)]);

  return null;
}
